import { graphql } from 'src/graphql';

import {
  AIModeratedTaskBlock,
  AIModeratedTaskBlockResearchGoal,
} from 'containers/Studies/data/fragments/AIModeratedTaskBlock.fragment';

export const CreateAIModeratedBooking = graphql(
  `
    mutation createAIModeratedBooking($input: CreateAIModeratedBookingInput!) {
      createAIModeratedBooking(input: $input) {
        _id
        name
        type
        status
        config {
          ai_moderated {
            intro_block {
              type
              title
              instructions
            }
            outro_block {
              type
              title
              instructions
            }
            task_blocks {
              ...AIModeratedTaskBlock
              ...AIModeratedTaskBlockResearchGoal
            }
            contexts {
              _id
              title
              type
              body
            }
          }
        }
      }
    }
  `,
  [AIModeratedTaskBlock, AIModeratedTaskBlockResearchGoal],
);
